export default __webpack_public_path__ + "static/media/provesional_restoration_lower_38_4@2x.5d5ce872.png";